/**
 * Constants for RichTextEditor
 */

// Color palette for text
export const TEXT_COLORS = [
  { name: 'Black', value: '#000000' },
  { name: 'Dark Gray', value: '#4a5568' },
  { name: 'Gray', value: '#718096' },
  { name: 'Light Gray', value: '#a0aec0' },
  { name: 'Red', value: '#e53e3e' },
  { name: 'Orange', value: '#dd6b20' },
  { name: 'Yellow', value: '#d69e2e' },
  { name: 'Green', value: '#38a169' },
  { name: 'Teal', value: '#319795' },
  { name: 'Blue', value: '#3182ce' },
  { name: 'Indigo', value: '#5a67d8' },
  { name: 'Purple', value: '#805ad5' },
  { name: 'Pink', value: '#d53f8c' },
] as const

// Color palette for highlights
export const HIGHLIGHT_COLORS = [
  { name: 'Yellow', value: '#fef08a' },
  { name: 'Green', value: '#bbf7d0' },
  { name: 'Blue', value: '#bfdbfe' },
  { name: 'Purple', value: '#e9d5ff' },
  { name: 'Pink', value: '#fbcfe8' },
  { name: 'Red', value: '#fecaca' },
  { name: 'Orange', value: '#fed7aa' },
  { name: 'Gray', value: '#e5e7eb' },
] as const

// Allowed tags for HTML sanitization
export const ALLOWED_HTML_TAGS = [
  'p',
  'br',
  'strong',
  'em',
  'u',
  's',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'ul',
  'ol',
  'li',
  'blockquote',
  'code',
  'pre',
  'a',
  'span',
  'mark',
] as const

// Allowed attributes for HTML sanitization
export const ALLOWED_HTML_ATTRS = ['href', 'target', 'rel', 'style', 'class'] as const

// Default styles for editor container
export const DEFAULT_EDITOR_STYLES = {
  border: '1px solid',
  borderColor: 'gray.200',
  borderRadius: '8px',
  width: '100%',
  minHeight: '150px',
  backgroundColor: 'white',
} as const
